/**
 * Authoritative pixel thresholds used by Metric View cards to pick a variant
 * based on their own rendered width (via `useCardWidth`). Kept in one place so
 * all cards agree and tuning stays easy.
 *
 * See `specs/metric-view-responsive/us1-responsive-layout.md` for the rationale
 * behind each threshold.
 */
/**
 * Shared chart-body height for the three middle-column cards on Metric View
 * (Cycle Time scatter, Throughput trend, WIP trend). Kept in one place so
 * every card stays visually aligned — a regression in PRODOPSAI-310 surfaced
 * when two different height values drifted during an earlier polish pass.
 */
export const METRIC_VIEW_CHART_HEIGHT = 170;

export const CARD_WIDTH_THRESHOLDS = {
  epic: {
    /** Below this: render the list variant instead of the bar chart */
    list: 500,
    /** Below this (and in list mode): drop the inline progress bar — headline + numbers only */
    miniList: 280,
    /** Below this (and still in chart mode): use EpicCompletionChart's compact=true */
    compactChart: 700,
  },
  scatter: {
    /** Below this: render the summary-line fallback instead of the scatter chart */
    summaryLine: 400,
  },
  trend: {
    /** Below this: render the sparkline fallback instead of the line chart */
    sparkline: 400,
  },
  p85: {
    /** Below this: render card-per-team stacked view */
    stacked: 350,
    /** Below this (but above stacked): table with horizontal scroll */
    scrollTable: 500,
  },
  wipSummary: {
    /** Below this: WIP Summary's two columns stack vertically instead of side-by-side */
    stackedCols: 500,
  },
  epicBreakdown: {
    /** Below this: render per-epic stacked cards instead of the 6-column table */
    stacked: 500,
  },
  codeQuality: {
    /** Below this: drop the SonarCloud icon-button from distribution-column rows;
     *  the whole row stays clickable for drill-through (PRODOPSAI-333). */
    rowIconDrop: 280,
  },
} as const;
